// Must match BE settings.report_in_background_threshold. When the number of
// selected ORPs exceeds this value, the report is generated in background and
// the link is e-mailed instead of streamed inline.
export const REPORT_IN_BACKGROUND_THRESHOLD = 5;

export const routes = {
  home: '/',
  upload: '/upload',
  paragraphs: '/paragraphs',
  reports: '/reports',
  predictions: '/predictions',
  contexts: '/contexts',
  bubble: '/bubble',
  metrics: '/metrics',
  apiTokens: '/api-tokens',
  promptEngineering: '/prompt-engineering',
  debugPrompt: '/debug-prompt',
  notFound: '*',
} as const;
